export default "__VITE_ASSET__cb3889df__"